import { ImplementorTemplateParams } from "components/stories/video-studio/utils/creatomate/setCustomTemplate";
import { ELEMENT_NAMES } from "components/stories/video-studio/utils/constants";
import { cacheAssetIfNeeded } from "../../utils/utils";
import findElementByName from "../../utils/findElementByName";

const activisionAllyTemplate = async ({
  preview,
  story
}: ImplementorTemplateParams) => {
  const { sourceUrl, name } = await cacheAssetIfNeeded(preview, story);

  const json = preview.getSource();
  const elements = json?.elements;
  const storyImageElement = findElementByName(elements, ELEMENT_NAMES.STORY);

  await preview.applyModifications({
    [`${storyImageElement?.id}.source`]: sourceUrl,
    [`${storyImageElement?.id}.name`]: name
  });
};

export default activisionAllyTemplate;
